import { render } from "./TemplateMfittBooking1.vue?vue&type=template&id=2d40dfce"
import script from "./TemplateMfittBooking1.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBooking1.vue?vue&type=script&lang=js"

import "./TemplateMfittBooking1.vue?vue&type=style&index=0&id=2d40dfce&socped=true&lang=css"
script.render = render

export default script